import { CustomTable, InputDate } from "medere-ui-framework"
import { useId, useRef, useState, BaseSyntheticEvent, useEffect } from "react"
import { Column } from "primereact/column"
import { getLastAccountingPeriod, getTSumBalance, exportTSumBalanceToPdf, getIntegrationBalance, exportIntegrationBalance, downloadFile } from "../servicesHooks/Accounting/useAccountingService"
import { AccountingPeriod } from "../interface/interface";
import { addDays, formatISO } from 'date-fns'
import { Button } from "primereact/button"
import Checkbox from '@mui/material/Checkbox';

function TSumOrIntegrationBalanceView() {
    const today = new Date()
    const tableRef = useRef(null)
    const [fromDate, setFromDate] = useState<Date|null>()
    const [toDate, setToDate] = useState<Date>(generateToDate())
    const [changeToIntegrationBalance, setChangeToIntegrationBalance] = useState(false)
    const tSumTableId = useId()
    const integrationTableId = useId()
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    useEffect(() => {
        generateFromDate()
    }, [changeToIntegrationBalance])

    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };
    
        window.addEventListener('resize', handleResize);
    
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const handleCheckboxChange = () => {
        setChangeToIntegrationBalance(!changeToIntegrationBalance);
    };

    function formatDate(date: Date) {
        return date.toISOString().split('T')[0];
    }
    
    function handleGeneratePDF() {
        if (fromDate && toDate) {
            const exportFunction = !changeToIntegrationBalance ? exportTSumBalanceToPdf : exportIntegrationBalance;
            exportFunction(fromDate, toDate)
        } else {
            console.log("fromDate o toDate undefined");
        }
    }    

    function generateFromDate() {
        if (!changeToIntegrationBalance)
            getLastAccountingPeriod({ offset: 0, pageSize: 50})
            .then((res:AccountingPeriod) => {
                    const newClosingDate = addDays(new Date(res.closingdate), 1);
                    const formattedClosingDate = formatISO(newClosingDate);
                    const nuevaFecha = new Date(formattedClosingDate)
                    setFromDate(nuevaFecha)
            }).catch(err => {
                    console.error("Error en getLastAccountingPeriod: ", err)
            })
        else {
            const currentDate = new Date();
            currentDate.setDate(currentDate.getDate() - 1);

            const year = currentDate.getFullYear();
            const month = currentDate.getMonth() + 1;
            const day = 1;

            const formattedMonth = month < 10 ? `0${month}` : month;
            const formattedDay = day < 10 ? `0${day}` : day;

            const formattedDate = `${year}-${formattedMonth}-${formattedDay}T03:00:00.000Z`;

            setFromDate(new Date(formattedDate))
        }
    }

    function generateToDate() {
        const currentDate = new Date();
        currentDate.setDate(currentDate.getDate());
      
        const year = currentDate.getFullYear();
        const month = currentDate.getMonth() + 1;
        const day = currentDate.getDate();
      
        const formattedMonth = month < 10 ? `0${month}` : month;
        const formattedDay = day < 10 ? `0${day}` : day;
      
        const formattedDate = `${year}-${formattedMonth}-${formattedDay}T03:00:00.000Z`;
      
        return new Date(formattedDate);
    }

    return (
        <div className="p-4 flex flex-column viewContainer">
            <h2 className="text-2xl">{!changeToIntegrationBalance? "Balance T de Sumas y Saldos":"Balance de Integración"}</h2>
            
            <div className='flex align-items-end justify-content-between gap-3'>
                <div className="flex flex-row gap-3 w-1/2">
                    <InputDate value={fromDate?fromDate:new Date()} label='Fecha asiento contable' onChange={(e: BaseSyntheticEvent) => {
                        setFromDate(e.target.value)
                    }}
                        className='w-1/2'
                        maxDate={today}
                    />

                    <InputDate value={toDate} label='Fecha asiento contable' onChange={(e: BaseSyntheticEvent) => {
                        setToDate(e.target.value)
                    }}
                        className='w-1/2'
                        maxDate={today}
                    />
                    
                    <label className={`${windowWidth <= 1211 || (windowWidth >= 1268 && windowWidth <= 1291) ? '-h-50' : 'h-0'} pd-0`} style={{display: 'flex', alignItems: 'center', marginTop:'60px'}}>
                        <span style={{fontSize: '15px'}}>Ver Balance de Integración:</span>
                        <Checkbox
                            checked={changeToIntegrationBalance}
                            onChange={handleCheckboxChange}
                            color="primary"
                            className="pd-0"
                        />
                    </label>
                </div>

                <div className="flex flex-end">
                    <Button
                        className="buttonMain"
                        icon='pi pi-file'
                        onClick={() => handleGeneratePDF()}
                    />     
                </div>
            </div>

            {!changeToIntegrationBalance &&
            <CustomTable
                idTable={tSumTableId}
                ref={tableRef}
                showGridlines
                hideFiltersButton
                getItems={getTSumBalance}
                params={{ 
                    fromDate: fromDate,
                    toDate: toDate
                }}
                className='crudTable'
            >
                <Column field="identifier" style={{ padding:'0px' }} header="Identificador" className="column" body={(record) => {
                        return <span style={{ paddingTop: '13px', paddingBottom: '13px', paddingLeft:record.identifier === '99999' ?'40%':'', paddingRight:record.identifier === '99999' ?'60%':'', background: record.identifier === '99999' ? '#FAFFB2' : 'inherit' }}>{record.identifier === '99999' ? '':record.identifier}</span>
                    }}/>
                <Column field="alias" style={{ padding:'0px' }} header="Alias" className="column" body={(record) => {
                        return <span style={{ paddingTop: '13px', paddingBottom: '13px', paddingLeft:record.identifier === '99999' ?'40%':'', paddingRight:record.identifier === '99999' ?'60%':'', background: record.identifier === '99999' ? '#FAFFB2' : 'inherit' }}>{record.identifier === '99999' ? '':record.alias}</span>
                    }}/>
                <Column field="descriptionaccountingaccount" style={{ padding:'0px' }} header="Descripción" className="column" body={(record) => {
                        return <span style={{ paddingTop: '13px', paddingBottom: '13px', paddingLeft:record.identifier === '99999' ?'40%':'', paddingRight:record.identifier === '99999' ?'60%':'', background: record.identifier === '99999' ? '#FAFFB2' : 'inherit' }}>{record.descriptionaccountingaccount}</span>
                    }}/>
                <Column field="sumdebit" style={{ padding:'0px' }} header="Acum.Débitos" className="column" body={(record) => {
                        return <span style={{ paddingTop:'13px', paddingBottom:'13px', paddingLeft:record.identifier === '99999' ?'35%':'', paddingRight:record.identifier === '99999' ?'65%':'', background: record.identifier === '99999' ? '#FAFFB2' : 'inherit' }}>{record.sumdebit}</span>
                    }}/>
                <Column field="sumcredit" style={{ padding:'0px' }} header="Acum.Créditos" className="column" body={(record) => {
                        return <span style={{ paddingTop:'13px', paddingBottom:'13px', paddingLeft:record.identifier === '99999' ?'35%':'', paddingRight:record.identifier === '99999' ?'65%':'', background: record.identifier === '99999' ? '#FAFFB2' : 'inherit' }}>{record.sumcredit}</span>
                    }}/>
                <Column field="debitbalance" style={{ padding:'0px' }} header="Sdos.Deudores" className="column" body={(record) => {
                        return <span style={{ paddingTop: '13px', paddingBottom: '13px', paddingLeft:record.identifier === '99999' ?'40%':'', paddingRight:record.identifier === '99999' ?'60%':'', background: record.identifier === '99999' ? '#FAFFB2' : 'inherit' }}>{record.identifier === '99999' ? '':record.debitbalance}</span>
                    }}/>
                <Column field="creditbalance" style={{ padding:'0px' }} header="Sdos.Acreedores" className="column" body={(record) => {
                        return <span style={{ paddingTop: '13px', paddingBottom: '13px', paddingLeft:record.identifier === '99999' ?'40%':'', paddingRight:record.identifier === '99999' ?'60%':'', background: record.identifier === '99999' ? '#FAFFB2' : 'inherit' }}>{record.identifier === '99999' ? '':record.creditbalance}</span>
                    }}/>
            </CustomTable>}

            {changeToIntegrationBalance &&
            <CustomTable
                idTable={integrationTableId}
                ref={tableRef}
                showGridlines
                hideFiltersButton
                getItems={getIntegrationBalance}
                params={{ 
                    fromDate: fromDate,
                    toDate: toDate
                }}
                className='crudTable'
            >
                <Column field="identifier" header="Código" className="column"/>
                <Column field="alias" header="Alias" className="column"/>
                <Column field="descriptionaccountingaccount" header="Descripción" className="column"/>
                <Column field="valueamd" header="" className="column" body={(record) => (record.valueamd !== 0 ? record.valueamd:null)}/>
            </CustomTable>}

        </div>
    )
    

}

export default TSumOrIntegrationBalanceView;
